export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const COLLECTIONS = [
  { slug: "signatures-feminines", name: "Les Signatures Féminines", short: "Pour elle", tagline: "Grâce, séduction, présence." },
  { slug: "signatures-masculines", name: "Les Signatures Masculines", short: "Pour lui", tagline: "Caractère, prestance, aplomb." },
  { slug: "choix-de-carine", name: "Les Choix de Carine", short: "Choix de Carine", tagline: "Sa sélection personnelle." },
];

export const HERO_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/1167ed6c-e30d-4f50-8c69-ef86b4454595/images/ab61c48961ee1d198f61704e8060cc9e7d6d5c9df5b32aec07c57f71cffb53a5.jpeg";

export const MAISON_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/1167ed6c-e30d-4f50-8c69-ef86b4454595/images/8cf87efc4b9f53d7f07ab4876a4e64ecb333d14aa11ce429b27b4930c9b91a1d.jpeg";

export const formatPrice = (v) =>
  `${Number(v || 0).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

export const waLink = (number, text) =>
  `https://wa.me/${String(number || "").replace(/\D/g, "")}?text=${encodeURIComponent(text)}`;
